<template>
  <el-row>
      <!-- 组织结构板块 - start -->
    <el-col :span="5">
        <div style="overflow-y: scroll">
            <div id="leftTreeId" style="height: 775px">
                <basic-container>
                    <div style="padding:1rem 0;">项目列表</div>
                    
                        <!-- <el-select v-model="projectId" placeholder="请选择" @change="projectSelectChangeHandler">
                            <el-option
                            v-for="item in projectList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select> -->


                        <el-tree
                            :data="projectList"
                            node-key="id"
                            default-expand-all
                             @node-click="projectSelectChangeHandler"
                            :props="defaultProps">
                        </el-tree>
                    <!-- <el-tree v-loading="treeLoading" lazy :load="getOrgList" :props="defaultProps" highlight-current @node-click="handleNodeClick"></el-tree> -->
                </basic-container>
            </div>
        </div>
    </el-col>
      <!-- 组织结构板块 - end -->
      
    <el-col :span="19" style="padding-bottom:4rem;">
      <!-- 扩展数据表列表板块 - start -->
        <!-- <avue-crud :data="data" :option="option" :page.sync="page" @on-load="onLoad"></avue-crud> -->
        <basic-container v-if="extensionTableVisible">
            <!-- <basic-container> -->
            <h2 style="text-align:center;">扩展数据表</h2>
            <avue-crud 
            v-loading="tableExtendLoading"
            :data="dataListExtension" 
            :option="optionExtend" 
            :page.sync="pageExtendOption"
             @on-load="onLoad(2)"
               :permission="permissionListExtend"
            >

                <template slot="menuLeft">

                    <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="openAddExtendTableDialog"
                    v-if="permission.table_extend_add" 
                    >
                    新增扩展数据表
                    </el-button>

                </template>

                <template slot="menu" slot-scope="scope">
                    <el-button v-if="permission.table_extend_status" type="text" icon="el-icon-setting" size="small" @click.native="switchExtendTableButtonHandler(scope.row.id,scope.row.status)">{{scope.row.status>0?"停用":"启用"}}</el-button>
                    <el-button v-if="permission.table_extend_edit" type="text" icon="el-icon-edit" size="small" @click.native="openEditExtendTableDialog(scope.row)">编辑</el-button>
                    <el-button v-if="permission.table_extend_design" type="text" icon="el-icon-s-operation" size="small" @click.native="toExtendTableFormDesign(scope.row.id,'extend')">表单设计</el-button>
                    <el-button v-if="permission.table_extend_view" type="text" icon="el-icon-view" size="small" @click.native="openViewExtendTableDialog(scope.row.id)">查看</el-button>
                    <el-button v-if="permission.table_extend_view" type="text" icon="el-icon-delete" size="small" @click.native="deleteExtendTableHandler(scope.row.id)">删除</el-button>
                </template>
                <template slot="status" slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status>0">{{"已启用"}}</el-tag>
                    <el-tag type="danger" v-else>{{"已停用"}}</el-tag>
                    <!-- <el-tag>{{scope.row.status>0?"已启用":"已停用"}}</el-tag> -->
                </template>
            </avue-crud>
        </basic-container>
      <!-- 扩展数据表列表板块 - end -->
      <!-- 共享数据表列表板块 - start -->
        <basic-container v-if="publicTableVisible">
            <h2 style="text-align:center;">共享数据表</h2>
            <avue-crud 
            v-loading="tableExtendLoading"
            :data="dataListPublic" 
            :option="optionPublic" 
            :page.sync="pagePublicOption"
            @on-load="onLoad(1)"
               :permission="permissionListPublic">
<!--  -->
                <template slot="menuLeft">

                    <el-button
                    type="success"
                    icon="el-icon-plus"
                    @click="openAddPublicTableDialog"
                    v-if="permission.table_public_add" 
                    >
                    新增共享数据表
                    </el-button>

                </template>
                <template slot="menu" slot-scope="scope">
                    <el-button v-if="permission.table_public_status" type="text" icon="el-icon-setting" size="small" @click.native="switchPublicTableButtonHandler(scope.row.id,scope.row.status)">{{scope.row.status>0?"停用":"启用"}}</el-button>
                    <el-button v-if="permission.table_public_edit" type="text" icon="el-icon-edit" size="small" @click.native="openEditPublicTableDialog(scope.row)">编辑</el-button>
                    <el-button v-if="permission.table_public_design" type="text" icon="el-icon-s-operation" size="small" @click.native="toPublicTableFormDesign(scope.row.id,'public')">表单设计</el-button>
                    <el-button v-if="permission.table_public_view" type="text" icon="el-icon-view" size="small" @click.native="openViewPublicTableDialog(scope.row.id)">查看</el-button>
                    <el-button v-if="permission.table_extend_view" type="text" icon="el-icon-delete" size="small" @click.native="deletePublicTableHandler(scope.row.id)">删除</el-button>
                </template>
                <template slot="status" slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status>0">{{"已启用"}}</el-tag>
                    <el-tag type="danger" v-else>{{"已停用"}}</el-tag>
                </template>
            </avue-crud>
        </basic-container>
      <!-- 共享数据表列表板块 - end -->
    </el-col>
    <!-- 新增表弹框 - start -->
    <el-dialog
        :title="isPublicTable?(isEdit?'编辑共享数据表':'新增共享数据表'):(isEdit?'编辑扩展数据表':'新增扩展数据表')"
        :visible.sync="dialogAddTableVisible"
        fullscreen
        append-to-body
    >
    <!-- 头部表单 - start -->
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="数据表名称" style="display:none;">
                <el-input placeholder="请输入数据表名称" name="tableName" v-model="publichead.tableName" v-if="tableType==1"></el-input>
                <el-input placeholder="请输入数据表名称" name="tableName" v-model="head.tableName" v-else></el-input>
            </el-form-item>
            <el-form-item label="数据表描述" required>
                <el-input placeholder="请输入数据表描述" name="publicTableDesc" v-model="publichead.publicTableDesc" v-if="tableType==1"></el-input>
                <el-input placeholder="请输入数据表描述" name="extendTableDesc" v-model="head.extendTableDesc" v-else></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input placeholder="请输入备注" name="remark" v-model="publichead.remark" v-if="tableType==1"></el-input>
                <el-input placeholder="请输入备注" name="remark" v-model="head.remark" v-else></el-input>
            </el-form-item>
        </el-form>
    <!-- 头部表单 - end -->
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="索引" name="index">索引</el-tab-pane>
    <el-tab-pane label="数据库属性" name="db">
        
    <!-- 标准表字段展示 - start -->
        <h3>标准表</h3>
        <el-table :data="dialogViewData.mainFields">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="字段名称" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldName" type="text" v-model="scope.row.dbFieldName" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段备注" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldDesc" type="text" v-model="scope.row.dbFieldDesc" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段长度" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbLength" type="text" v-model="scope.row.dbLength" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="小数点" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbPointLength" type="text" v-model="scope.row.dbPointLength" disabled @keyup.native="regNumber"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="默认值" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbDefaultVal" type="text" v-model="scope.row.dbDefaultValue" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段类型" width=""> 
                    <template slot-scope="scope">
                        <el-select name="dbType" v-model="scope.row.dbType" placeholder="请选择" disabled @change="selectChangeHandler">
                            <el-option
                            v-for="item in getDbType"
                            :key="item.dictValue"
                            :label="item.dictValue"
                            :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="主键" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" disabled></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="允许空值" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" disabled></el-checkbox>
                    </template>
                </el-table-column>
        </el-table>
        
    <!-- 标准表字段展示 - end -->
    <!-- 共享表字段展示 - start -->
        <div v-if="!isPublicTable">
            <h3>共享表</h3>
            <el-table :data="dialogViewData.publicFields">
                <el-table-column type="index"></el-table-column>
                <el-table-column label="字段名称" width=""> 
                        <template slot-scope="scope">
                            <el-input name="dbFieldName" type="text" v-model="scope.row.dbFieldName" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="字段备注" width=""> 
                        <template slot-scope="scope">
                            <el-input name="dbFieldDesc" type="text" v-model="scope.row.dbFieldDesc" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="字段长度" width=""> 
                        <template slot-scope="scope">
                            <el-input name="dbLength" type="text" v-model="scope.row.dbLength" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="小数点" width=""> 
                        <template slot-scope="scope">
                            <el-input name="dbPointLength" type="text" v-model="scope.row.dbPointLength" disabled @keyup.native="regNumber"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="默认值" width=""> 
                        <template slot-scope="scope">
                            <el-input name="dbDefaultVal" type="text" v-model="scope.row.dbDefaultValue" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="字段类型" width=""> 
                        <template slot-scope="scope">
                            <el-select name="dbType" v-model="scope.row.dbType" placeholder="请选择" disabled @change="selectChangeHandler">
                                <el-option
                                v-for="item in getDbType"
                                :key="item.dictValue"
                                :label="item.dictValue"
                                :value="item.dictKey">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="主键" width=""> 
                        <template slot-scope="scope">
                            <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" disabled></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="允许空值" width=""> 
                        <template slot-scope="scope">
                            <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" disabled></el-checkbox>
                        </template>
                    </el-table-column>
            </el-table>
        </div>
    <!-- 共享表字段展示 - end -->
    <!-- 添加表字段模块 - start -->
        <el-button @click="addTableData" 
                    type="primary"
                    icon="el-icon-plus" style="margin:2rem 0;">
            添加字段
        </el-button>
        <!-- <el-table :data="isEdit?(isPublicTable?(tableData=dialogViewData.publicFields):(tableData=dialogViewData.extendFields)):tableData" id="tableEditBox"> -->
        <el-table :data="tableData" id="tableEditBox"> 
            
            <el-table-column type="index"></el-table-column>
            <el-table-column label="操作">
                
                    <template slot-scope="scope">
                <el-button type="danger" v-if="!(scope.$index<2)" @click="delHandler(scope)">删除</el-button>
                    </template>
            </el-table-column>
            <el-table-column label="字段名称" width="">
                    <template slot="header" slot-scope="scope">
                        字段名称<span style="color:red;">*</span>
                    </template> 
                    <template slot-scope="scope">
                        
                        <el-input name="dbFieldName" type="text" v-model="scope.row.dbFieldName" :disabled="scope.$index<2"></el-input>
                       
                    </template>
                </el-table-column>
                <el-table-column label="字段备注" width=""> 
                    <template slot="header" slot-scope="scope">
                        字段备注<span style="color:red;">*</span>
                    </template> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldDesc" type="text" v-model="scope.row.dbFieldDesc" :disabled="scope.$index<2"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段长度" width=""> 
                    <template slot="header" slot-scope="scope">
                        字段长度<span style="color:red;">*</span>
                    </template> 
                    <template slot-scope="scope">
                        <el-input name="dbLength" type="text" v-model="scope.row.dbLength" :disabled="scope.$index<2"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="小数点" width=""> 
                    <template slot="header" slot-scope="scope">
                        小数点<span style="color:red;">*</span>
                    </template> 
                    <template slot-scope="scope">
                        <el-input name="dbPointLength" type="text" v-model="scope.row.dbPointLength" :disabled="true" @keyup.native="regNumber"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="默认值" width=""> 
                    <template slot="header" slot-scope="scope">
                        默认值<span style="color:red;">*</span>
                    </template> 
                    <template slot-scope="scope">
                        <el-input name="dbDefaultVal" type="text" v-model="scope.row.dbDefaultValue" :disabled="scope.$index<2"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段类型" width=""> 
                    <template slot="header" slot-scope="scope">
                        字段类型<span style="color:red;">*</span>
                    </template> 
                    <template slot-scope="scope">
                        <el-select name="dbType" v-model="scope.row.dbType" placeholder="请选择" :disabled="scope.$index<2" @change="selectChangeHandler">
                            <el-option
                            v-for="item in getDbType"
                            :key="item.dictValue"
                            :label="item.dictValue"
                            :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="主键" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" @change="showCheckBoxValueDbIsKey" disabled></el-checkbox>
                        <!-- <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" @change="showCheckBoxValueDbIsKey" :disabled="scope.$index<2"></el-checkbox> -->
                    </template>
                </el-table-column>
                <el-table-column label="允许空值" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" @change="showCheckBoxValueDbIsNull" disabled></el-checkbox>
                        <!-- <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" @change="showCheckBoxValueDbIsNull" :disabled="scope.$index<2"></el-checkbox> -->
                    </template>
                </el-table-column>
        </el-table>
    <!-- 添加表字段模块 - end -->
    </el-tab-pane>
    </el-tabs>
        <div style="text-align:right;margin-top:2rem;">
            <el-button @click="getTableData" :disabled="submitBtnDisabled" type="primary">
                提交数据
            </el-button>
        </div>
    </el-dialog>
    <el-dialog
        :title="isPublicTable?'查看共享数据表':'查看扩展数据表'"
        :visible.sync="dialogViewTableVisible"
        fullscreen
        append-to-body
    >
    <tabledialog-viewbox :viewdata="dialogViewData" @getMessageFromChild="getMessageFromChild"/>
    </el-dialog>
    <!-- 新增表弹框 - end -->
  </el-row>
</template>

<script>
import TabledialogViewbox from './table-view-dialog-box.vue'
import { 
    getDeptTreeList,
    getDeptChildrenTreeList,
    getDbtypeList, 
    getExtensionTableList, 
    getPublicTableList,
    submitPublicTableDataList,
    submitExtendTableDataList,
    switchExtendTableButton,
    switchPublicTableButton,
    getTableFieldListDetail,
    getTableFieldListDetailByID,
    removePublicTable,
    removeExtendTable,
    getProjectList,
} from '@/api/table-extension/table-extension-design'
import {mapGetters} from "vuex";
export default {
    components:{TabledialogViewbox},
 data() {
      return {
          projectId:'',
          projectList:'',
          pageUrl_:'',
          isEdit:false,
          treeLoading:true,
          tableExtendLoading:true,
          tablePublicLoading:true,
          page:{
              pageSize: 10,
                currentPage: 1,
                total: 15
          },
        dialogViewTableVisible:false,
        //   viewDialogVisible:false,
          dialogViewData:{},
          btnAuth:{},
          pagePublicOption:{
              pageSize: 10,
                currentPage: 1,
                total: 0
          },
          pageExtendOption:{
              pageSize: 10,
                currentPage: 1,
                total: 0
          },
          deptId:'',
          publichead: {
                pageUrl: '',
                tableName: "",
                publicTableDesc: "",
                remark: ""
            },
          head: {
                pageUrl: '',
                tableName: "",
                extendTableDesc: "",
                remark: ""
            },
          tableType:0,
          submitBtnDisabled:false,
          isInputEmptyCounts:0,
          isPublicTable:false,
          publicTableVisible:false,
          extensionTableVisible:false,
          defaultProps:{
            label: "name"
          },
          activeName:'db',
          dialogAddTableVisible:false,
        dataListPublic: [
          {
            dbTable:'扩展表名001',
            deptName:'青山区华润医院',
            date:'1994-02-23 00:00:00',
            person:'尼古拉斯赵四'
          }
        ],
        dataListExtension: [
          {
            dbTable:'扩展表名001',
            deptName:'青山区华润医院',
            date:'1994-02-23 00:00:00',
            person:'尼古拉斯赵四'
          }
        ],
        tableDataId:'',
        tableData: [{
            dbFieldName: 'id',
            dbFieldDesc: '主键',
            queryDictField: '',
            queryDictText: '',
            queryDefVal: '',
            queryDictTable: '',
            queryConfigFlag: '0',
            mainTable: '',
            mainField: '',
            fieldHref: '',
            dictField: '',
            dictText: '',
            fieldMustInput: '0',
            dictTable: '',
            fieldLength: '120',
            fieldDefaultValue: '',
            fieldExtendJson: '',
            converter: '',
            isShowForm: '0',
            isShowList: '0',
            sortFlag: '0',
            isReadOnly: '1',
            fieldShowType: 'text',
            isQuery: '0',
            queryMode: 'single',
            dbLength: '64',
            dbPointLength: '0',
            dbDefaultValue: '',
            orderNum: '1',
            dbType: '3',
            dbIsKey: true,
            dbIsNull: false,
            order_num: '0'
        },{
            dbFieldName: 'main_id',
            dbFieldDesc: '主表id',
            queryDictField: '',
            queryDictText: '',
            queryDefVal: '',
            queryDictTable: '',
            queryConfigFlag: '0',
            mainTable: '',
            mainField: '',
            fieldHref: '',
            dictField: '',
            dictText: '',
            fieldMustInput: '0',
            dictTable: '',
            fieldLength: '120',
            fieldDefaultValue: '',
            fieldExtendJson: '',
            converter: '',
            isShowForm: '0',
            isShowList: '0',
            sortFlag: '0',
            isReadOnly: '1',
            fieldShowType: 'text',
            isQuery: '0',
            queryMode: 'single',
            dbLength: '64',
            dbPointLength: '0',
            dbDefaultValue: '',
            orderNum: '1',
            dbType: '3',
            dbIsKey: false,
            dbIsNull: false,
            order_num: '0'
        }],
        getDbType:[{
                label:'string',
                value:'string'
            },{
                label:'string1',
                value:'string1'
            },{
                label:'string2',
                value:'string2'
            },{
                label:'string3',
                value:'string3'
            },{
                label:'string4',
                value:'string4'
            }],
        optionPublic:{
            editBtn: false,
            addBtn: false,
            delBtn: false,
            title:'表格的标题',
            align:'center',
            menuAlign:'center',
            column:[
            {
                label:'数据表名',
                prop:'publicTableName',
            },
            {
              label:'组织部门',
              prop:'createDept',
              hide: true,
            },{
                label:'表说明',
                prop:'publicTableDesc',
              },{
              label: "操作时间",
              prop: "updateTime",
              type: "date",
              format: "yyyy-MM-dd hh:mm:ss",
              valueFormat: "yyyy-MM-dd hh:mm:ss",
            },{
              label:'操作人',
              prop:'updateUserName',
            },
            {
                label:'状态',
                prop:'status',
                slot:true
            },
          ]
        },
        optionExtend:{
            editBtn: false,
            addBtn: false,
            delBtn: false,
            title:'表格的标题',
            align:'center',
            menuAlign:'center',
            column:[
            {
                label:'数据表名',
                prop:'extendTableName',
            },
              {
                label:'组织部门',
                prop:'createDept',
                hide: true,
              },{
                label:'表说明',
                prop:'extendTableDesc',
              },{
              label: "操作时间",
              prop: "updateTime",
              type: "date",
              format: "yyyy-MM-dd hh:mm:ss",
              valueFormat: "yyyy-MM-dd hh:mm:ss",
            },{
              label:'操作人',
              prop:'updateUserName',
            },
            {
                label:'状态',
                prop:'status',
                slot:true
            },
          ]
        }
      }
    },
    filters: {
  parseBoolean(val){
            console.log(Boolean(val));
            return Boolean(val);
        }
},
created(){
    getProjectList().then((res)=>{
        console.log(res.data);
        this.projectList = res.data.data;
        console.log("this.projectList====>",this.projectList);


        
    });
    // console.log(tools);
    this.pageUrl_ = this.$route.query.pageUrl;
    console.log(this.pageUrl_);
    let self = this;
    this.tableData.forEach((e,i)=>{
        self.tableData[i].dbIsKey = (parseInt(e.dbIsKey)>0?true:false);
        self.tableData[i].dbIsNull = (parseInt(e.dbIsNull)>0?true:false)
    });
    console.log(this.tableData);
    getDbtypeList().then((res)=>{
        let arrayDbtypeList = [];
        res.data.data.forEach((el,index)=>{
            if(parseInt(el.dictKey)==6||parseInt(el.dictKey)==7||parseInt(el.dictKey)==8){
                // console.log('index====================>',index);
                // res.data.data.splice(index,1);
            }else{
                arrayDbtypeList.push(el);
            }
        })
        this.getDbType = arrayDbtypeList;
        console.log(this.getDbType);
    })
    console.log(JSON.parse(localStorage.getItem('saber-userInfo')).content.role_name);
    console.log(JSON.parse(localStorage.getItem('saber-permission')).content);
},
computed: {
    //获取共享表按钮操作权限;
      ...mapGetters(["permission"]),
      permissionListPublic(){
          return{
              delBtn:this.permission.table_public_delete
          }
      },
    //获取扩展表按钮操作权限;
      permissionListExtend(){
          return{
              delBtn:this.permission.table_extend_delete
          }
      },
      getAddress: {
        get: function () {
          if(this.$store.state.updateAddress){
            this.address = this.$store.state.updateAddress
          }
          return this.address
        },
        set: function (value) {
          this.address = value
        },
      },
    },
 
    methods:{
        projectSelectChangeHandler(val){
            
                    this.publicTableVisible = true;
                    this.extensionTableVisible = true;
                    console.log('根节点');
                    // this.projectId = data.value;
                    this.projectId = val.id;
                        this.tablePublicLoading = true;
                    getPublicTableList(this.pageUrl_,1,10).then(({ data })=>{
                        console.log("共享表列表===>",data.data.records);
                        this.pagePublicOption.total = data.data.total
                            this.pagePublicOption.pageSize = data.data.size,
                            this.pagePublicOption.currentPage = data.data.current
                        this.dataListPublic = data.data.records;
                        console.log(this.pagePublicOption);
                        this.tablePublicLoading = false;
                    });
                        this.tableExtendLoading = true;
                    getExtensionTableList(this.pageUrl_,1,10,this.projectId).then(({ data })=>{
                        console.log("扩展表列表===>",data.data.records);
                        
                        this.pageExtendOption.total = data.data.total
                        this.pageExtendOption.pageSize = data.data.size,
                        this.pageExtendOption.currentPage = data.data.current

                        this.dataListExtension = data.data.records;
                        console.log(this.pageExtendOption);
                        this.tableExtendLoading = false;
                    });
        },
        showCheckBoxValueDbIsKey(value){
            console.log(value)
        },
        showCheckBoxValueDbIsNull(value){
            console.log(value)
        },
        getExtendFieldsData(){
            this.tableData = this.dialogViewData.extendFields;
            return this.tableData;
        },
        // ...tools,
        //分页更新---分页表数据更新方法
        onLoad(tableId){
                if(parseInt(tableId)==1){
                    console.log(this.pagePublicOption);
                        this.tablePublicLoading = true;
                    getPublicTableList(this.pageUrl_,this.pagePublicOption.currentPage,this.pagePublicOption.pageSize).then(({ data })=>{
                        console.log("共享表列表===>",data.data.records);
                        this.pagePublicOption = {
                            total:data.data.total,
                            pageSize:data.data.size,
                            currentPage:data.data.current
                        }
                        this.dataListPublic = data.data.records;
                        console.log(this.pagePublicOption);
                        this.tablePublicLoading = false;
                    });
                }else{
                        this.tableExtendLoading = true;
                    getExtensionTableList(this.pageUrl_,this.pageExtendOption.currentPage,this.pageExtendOption.pageSize,this.projectId).then(({ data })=>{
                        console.log("扩展表列表===>",data.data.records);
                        this.dataListExtension = data.data.records;
                        this.pageExtendOption = {
                            total:data.data.total,
                            pageSize:data.data.size,
                            currentPage:data.data.current
                        }
                        this.tableExtendLoading = false;
                    });
                    
                }
        },
        
        //分页数据更新方法
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      
        //分页数据更新方法
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
        getMessageFromChild(val){
            console.log(val);
        },
        // 开启共享表预览弹框
        openViewPublicTableDialog(tableid){
            getTableFieldListDetailByID(tableid,1).then((res)=>{
                console.log(res.data.data);
                this.dialogViewData = res.data.data;
            })
            this.isPublicTable = true;
            this.dialogViewTableVisible = true;
        },
        // 开启扩展表预览弹框
        openViewExtendTableDialog(tableid){
            getTableFieldListDetailByID(tableid,2).then((res)=>{
                console.log(res.data.data);
                this.dialogViewData = res.data.data;
            })
            this.isPublicTable = false;
            this.dialogViewTableVisible = true;
        },
        // 跳转到扩展表表单设计页面
        toExtendTableFormDesign(tableid,type){
            if (
        document.querySelector(
          'div[id*="tab-/form-design/form-design-list"]>span[class="el-icon-close"]'
        )
      ) {
        document
          .querySelector(
            'div[id*="tab-/form-design/form-design-list"]>span[class="el-icon-close"]'
          )
          .click();
      }
            this.$router.push(`/form-design/form-design-list?tableid=${tableid}&type=${type}&projectId=${this.projectId}&pageUrl=${this.pageUrl_}`);
        },
        // 跳转到共享表表单设计页面
        toPublicTableFormDesign(tableid,type){
                    if (
                document.querySelector(
                'div[id*="tab-/form-design/form-design-list"]>span[class="el-icon-close"]'
                )
            ) {
                document
                .querySelector(
                    'div[id*="tab-/form-design/form-design-list"]>span[class="el-icon-close"]'
                )
                .click();
            }
            this.$router.push(`/form-design/form-design-list?tableid=${tableid}&type=${type}&projectId=${this.projectId}&pageUrl=${this.pageUrl_}`);
        },
        //共享数据表开关方法
        switchPublicTableButtonHandler(id,statu){
            let status = 0;
            if(statu>0){
                status = 0;
            }else{
                status = 1;
            }
            this.$confirm('是否继续操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                switchPublicTableButton({id,status,pageUrl:this.pageUrl_}).then((res)=>{
                    
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    console.log(res);

                    if(res.data.success){
                        this.tablePublicLoading = true;
                        getPublicTableList(this.pageUrl_,1,10).then(({ data })=>{
                            console.log("共享表列表===>",data.data.records);
                            this.dataListPublic = data.data.records;
                            this.pagePublicOption = {
                                total:data.data.total,
                                pageSize:data.data.size,
                                currentPage:data.data.current
                            }
                            this.tablePublicLoading = false;
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        //扩展数据表开关方法
        switchExtendTableButtonHandler(id,statu){
            let status = 0;
            if(statu>0){
                status = 0;
            }else{
                status = 1;
            }
            this.$confirm('是否继续操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                switchExtendTableButton({id,status,pageUrl:this.pageUrl_,projectId:this.projectId}).then((res)=>{
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    console.log(res);
                    if(res.data.success){
                        
                        this.tableExtendLoading = true;
                        getExtensionTableList(this.pageUrl_,1,10,this.projectId).then(({ data })=>{
                            console.log("扩展表列表===>",data.data.records);
                            this.dataListExtension = data.data.records;
                            this.pageExtendOption = {
                                total:data.data.total,
                                pageSize:data.data.size,
                                currentPage:data.data.current
                            }
                        this.tableExtendLoading = false;
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        regNumber(e){
            e.target.value=e.target.value.replace(/[^\d]/g,'')
        },
        // 验证重复元素，有重复返回true；否则返回false
            isRepeat(arr){
            var hash = {};
            for(var i in arr) {
                if(hash[arr[i].value]) {
            // return true;
                return {isRepeat:true,el:arr[i].el};
                }
                // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
                hash[arr[i].value] = true;
            }
            // return false;
                return {isRepeat:false,el:''};
            },
                                // 点击树
            handleNodeClick(data) {
                console.log("点击树节点");
                console.log(data);
                if(parseInt(data.parentId)==0){
                    this.publicTableVisible = true;
                    this.extensionTableVisible = true;
                    console.log('根节点');
                    this.projectId = data.value;
                        this.tablePublicLoading = true;
                    getPublicTableList(this.pageUrl_,1,10).then(({ data })=>{
                        console.log("共享表列表===>",data.data.records);
                        this.pagePublicOption.total = data.data.total
                            this.pagePublicOption.pageSize = data.data.size,
                            this.pagePublicOption.currentPage = data.data.current
                        this.dataListPublic = data.data.records;
                        console.log(this.pagePublicOption);
                        this.tablePublicLoading = false;
                    });
                        this.tableExtendLoading = true;
                    getExtensionTableList(this.pageUrl_,1,10,data.value).then(({ data })=>{
                        console.log("扩展表列表===>",data.data.records);
                        
                        this.pageExtendOption.total = data.data.total
                        this.pageExtendOption.pageSize = data.data.size,
                        this.pageExtendOption.currentPage = data.data.current

                        this.dataListExtension = data.data.records;
                        console.log(this.pageExtendOption);
                        this.tableExtendLoading = false;
                    });
                }else{
                    this.projectId = data.value;
                    this.publicTableVisible = false;
                    this.extensionTableVisible = true;
                    console.log('子节点');
                        this.tableExtendLoading = true;
                    getExtensionTableList(this.pageUrl_,1,10,data.value).then(({ data })=>{
                        console.log("扩展表列表===>",data.data.records);
                        this.dataListExtension = data.data.records;
                        this.pageExtendOption.total = data.data.total
                        this.pageExtendOption.pageSize = data.data.size,
                        this.pageExtendOption.currentPage = data.data.current
                        this.tableExtendLoading = false;
                    });
                }
            },               
        /**
             * 懒加载树获取组织机构子节点
             * element-tree使用方法
             * @param node:当前点击节点信息
             * @param resolve:传递参数方法
             * */
            getOrgList(node,resolve) {
                let self = this;
                console.log(node);
                if(node.level == 0){
                    getDeptTreeList().then(res => {
                        console.log(res.data)
                        let treeData = []
                        res.data.data.forEach(e => {
                            treeData.push(e)
                        })
                        resolve(treeData);
                        this.treeLoading = false;
                    }).catch(res => {
                        resolve([]);
                    })
                }else{
                    console.log("当前节点id值为："+node.data.id)
                    getDeptChildrenTreeList('',node.data.id).then(res => {
                        let myList = [];
                        res.data.data.forEach(e => {
                            myList.push(e)
                        })
                        resolve(myList);
                    }).catch(res => {
                        resolve([]);
                    })

                }

            },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        parseBoolean(val){
            console.log(Boolean(val));
            return Boolean(val);
        },
        delHandler(row){
            console.log(row);
            console.log(this.tableData);
            this.tableData = this.tableData.filter((e,i)=>!(i===row.$index));
            console.log(this.tableData);
        },
        submitBtnDisabledHandler(){
            this.submitBtnDisabled = true;
        },
        addTableData(){
            this.tableData.push({
                    dbFieldName: '',
                    dbFieldDesc: '',
                    dbLength: '36',
                    dbPointLength: '0',
                    dbDefaultValue: '',
                    orderNum: '1',
                    dbType: '1',
                    dbIsKey: false,
                    dbIsNull: false,
                });
            this.bindInputBlurEventHandler();
            this.bindSelectBlurHandler();
        },
        getTableData(){
            let isBigDecimal = false;
            let isInteger = false;
            let isDate = false;
            let dbFieldNameList = [];
            this.isInputEmptyCounts = 0;
            console.log(this.tableData);
            
            //校验表头表单input输入框信息
            let _el_ = document.querySelector('#tableEditBox');

            
            //重置input框样式;
            _el_.querySelectorAll('input')
            .forEach((e)=>{
                e.style.border = '';
            });

                    document.querySelector('input[name="tableName"]').style.border = '';
                    if(this.tableType==2){

                        document.querySelector('input[name="extendTableDesc"]').style.border = '';
                    }else{

                        document.querySelector('input[name="publicTableDesc"]').style.border = '';
                    }
            if(this.tableType==2){

                // if(!this.head.tableName){
                //     document.querySelector('input[name="tableName"]').style.border = '1px solid red';
                //     this.$message.error('请填写数据表名称！');
                //     return;
                // }
                if(!this.head.extendTableDesc){
                    document.querySelector('input[name="extendTableDesc"]').style.border = '1px solid red';
                    this.$message.error('请填写数据表描述！');
                    return;
                }
            }else{
                // if(!this.publichead.tableName){
                //     document.querySelector('input[name="tableName"]').style.border = '1px solid red';
                //     this.$message.error('请填写数据表名称！');
                //     return;
                // }
                if(!this.publichead.publicTableDesc){
                    document.querySelector('input[name="publicTableDesc"]').style.border = '1px solid red';
                    this.$message.error('请填写数据表描述！');
                    return;
                }
            }

            // //给input输入框绑定事件
            // _el_.querySelectorAll('div.el-table__body-wrapper.is-scrolling-none > table input.el-input__inner')
            // .forEach((e)=>{
            //     e.focus();
            //     e.blur();
            // });

            //获取所有数据表字段列表
            _el_.querySelectorAll('input[name="dbFieldName"]')
            .forEach((e)=>{
                console.log(e.value);
                if(e.value){
                    // dbFieldNameList.push({value:e.value,e});
                    dbFieldNameList.push({value:e.value,el:e});
                }
            });


            
            //判断数据表字段名是否有重复
            if(dbFieldNameList.length){
                // dbFieldNameList.forEach((e)=>{

                // });
                console.log(dbFieldNameList);
                console.log("isRepeat ====> "+JSON.stringify(this.isRepeat(dbFieldNameList)));
                let elNode = this.isRepeat(dbFieldNameList);
                if(elNode.isRepeat){
                    this.$message.error(`字段名称"${elNode.el.value}"重复！`);
                    console.log(elNode.el);
                    elNode.el.style.border = '1px solid red';
                    return;
                }
            }
            console.log(dbFieldNameList);


            let integerTest_ = /^[1-9]\d*$/
            //校验BigDecimal类型的字段名小数位是否符合规则
            _el_.querySelectorAll('input[name="dbType"]')
            .forEach((e,i)=>{
                console.log(e.value);
                if(e.value==="BigDecimal"){
                    console.log(e,i);
                    // dbFieldNameList.push({value:e.value,e});
                    if(parseInt(_el_.querySelectorAll('input[name="dbPointLength"]')[i].value)>parseInt(_el_.querySelectorAll('input[name="dbLength"]')[i].value)){
                        // console.log('invalid type!');
                        isBigDecimal = true;
                        _el_.querySelectorAll('input[name="dbPointLength"]')[i].style.border = '1px solid red';
                    }
                    
                    // dbFieldNameList.push({value:e.value,e});
                    if(!integerTest_.test(_el_.querySelectorAll('input[name="dbDefaultVal"]')[i].value)){
                        // console.log('invalid type!');
                        isBigDecimal = true;
                        _el_.querySelectorAll('input[name="dbDefaultVal"]')[i].style.border = '1px solid red';
                    }
                    // dbFieldNameList.push({value:e.value,el:e});
                }
            });
            if(isBigDecimal){
                this.$message.error('BigDecimal格式不正确！')
                return;
            }

            let dateTest = /^\d{4}(\-|\/|\.)\d{1,2}\1\d{1,2}$/
            let integerTest = /^[1-9]\d*$/
            //校验Date类型的默认值格式
            _el_.querySelectorAll('input[name="dbType"]')
            .forEach((e,i)=>{
                console.log(e.value);
                if(e.value==="Date"){
                    console.log(e,i);
                    // dbFieldNameList.push({value:e.value,e});
                    if(!dateTest.test(_el_.querySelectorAll('input[name="dbDefaultVal"]')[i].value)){
                        // console.log('invalid type!');
                        isDate = true;
                        _el_.querySelectorAll('input[name="dbDefaultVal"]')[i].style.border = '1px solid red';
                    }
                    // dbFieldNameList.push({value:e.value,el:e});
                }
                console.log(e.value);
                if(e.value==="Integer"){
                    console.log("Integer=======================>",e,i);
                    // dbFieldNameList.push({value:e.value,e});
                    if(!integerTest.test(_el_.querySelectorAll('input[name="dbDefaultVal"]')[i].value)){
                        // console.log('invalid type!');
                        isInteger = true;
                        _el_.querySelectorAll('input[name="dbDefaultVal"]')[i].style.border = '1px solid red';
                    }
                    // dbFieldNameList.push({value:e.value,el:e});
                }
            });
            if(isDate){
                this.$message.error('Date类型默认值格式不正确！格式为"YYYY/MM/DD"!');
                return;
            }
            if(isInteger){
                this.$message.error('Integer类型默认值格式不正确！格式为"正整数"!');
                return;
            }

            let illegalDbFieldName = false;
            // let emptyDbFieldName = false;
            //校验字段名称格式。
            _el_.querySelectorAll('input[name="dbFieldName"]')
            .forEach((e,i)=>{
                console.log(e.value);
                let dbFieldNameTest = /^[a-zA-Z][a-zA-Z0-9_]*$/;
                // if(!e.value){
                //     emptyDbFieldName = true;
                // }
                if(!dbFieldNameTest.test(e.value)){
                    illegalDbFieldName = true;
                    _el_.querySelectorAll('input[name="dbFieldName"]')[i].style.border = '1px solid red';
                }
                // if(e.value==="BigDecimal"){
                //     console.log(e,i);
                //     // dbFieldNameList.push({value:e.value,e});
                //     if(parseInt(_el_.querySelectorAll('input[name="dbPointLength"]')[i].value)>parseInt(_el_.querySelectorAll('input[name="dbLength"]')[i].value)){
                //         // console.log('invalid type!');
                //         isBigDecimal = true;
                //         _el_.querySelectorAll('input[name="dbPointLength"]')[i].style.border = '1px solid yellow';
                //     }
                //     // dbFieldNameList.push({value:e.value,el:e});
                // }
            });
            // if(emptyDbFieldName){
            //     this.$message.error('字段名称格式不能为空！')
            //     return;
            // }
            if(illegalDbFieldName){
                this.$message.error('字段名称格式不正确！请以字母开头并使用字母加数字！')
                return;
            }
            //给input输入框绑定事件
            _el_.querySelectorAll('div.el-table__body-wrapper.is-scrolling-none > table input.el-input__inner')
            .forEach((e)=>{
                e.focus();
                e.blur();
            });
            //校验数据表表单是否填完了。
                if(this.isInputEmptyCounts){
                    this.$message.error('表单未填写完!');
                    return;
                }

                console.log('表单填写完了!');

                

                //提交表数据。
                this.submitTableData();

        },
        transformBooleanToNumber(){
            let tableDataList = [];
            this.tableData.forEach((e,i)=>{
                console.log(e);
                // if(parseInt(e.dbIsKey)){

                if(parseInt(e.dbType)==2){
                    e.dbDefaultValue = parseInt(e.dbDefaultValue);
                }
                if(e.dbIsKey){
                    e.dbIsKey= 1;
                    
                }else{
                    e.dbIsKey = 0;
                }

                // if(parseInt(e.dbIsNull)){
                if(e.dbIsNull){
                    e.dbIsNull= 1;
                    
                }else{
                    e.dbIsNull = 0;
                }
                // if(e.dbFieldName==='id'){

                // }else{
                    tableDataList.push(e);

                // }
            });
            return tableDataList
        },
        submitTableData(){
            let self = this; 

            this.head.pageUrl = this.pageUrl_;
            this.publichead.pageUrl = this.pageUrl_;
            let head = this.head;
            let publichead = this.publichead;
            console.log(self.transformBooleanToNumber());
            let editTableDataId = this.isEdit?this.tableDataId:'';
            publichead['id'] = editTableDataId;
            // return;
            // console.log(self.transformBooleanToNumber());
            if(self.tableType==1){
                submitPublicTableDataList({
                    head:publichead,
                    fields:self.transformBooleanToNumber(),
                    indexs:[{
                        indexName:'666',
                        indexField:'id',
                        indexType:0
                    }]
                }).then((res)=>{
                    console.log(res);
                        this.dialogAddTableVisible = false;
                    if(res.data.success){
                        this.tablePublicLoading = true;
                        getPublicTableList(this.pageUrl_,1,10).then(({ data })=>{
                            console.log("共享表列表===>",data.data.records);
                            this.dataListPublic = data.data.records;
                            this.pagePublicOption = {
                                total:data.data.total,
                                pageSize:data.data.size,
                                currentPage:data.data.current
                            }
                            this.tablePublicLoading = false;
                        });
                    }
                });
            }else{
                head.projectId = self.projectId;
                head['id'] = editTableDataId;
                submitExtendTableDataList({
                    head:head,
                    fields:self.transformBooleanToNumber(),
                    indexs:[{
                        indexName:'666',
                        indexField:'id',
                        indexType:0
                    }]
                }).then((res)=>{
                    console.log(res);
                    if(res.data.success){
                        this.dialogAddTableVisible = false;
                        this.tableExtendLoading = true;
                        getExtensionTableList(this.pageUrl_,1,10,this.projectId).then(({ data })=>{
                            console.log("扩展表列表===>",data.data.records);
                            this.dataListExtension = data.data.records;
                            this.pageExtendOption = {
                                total:data.data.total,
                                pageSize:data.data.size,
                                currentPage:data.data.current
                            }
                        this.tableExtendLoading = false;
                        });
                    }
                });
            }
        },
        getDbType(){
            return [{
                label:'string',
                value:'string'
            },{
                label:'string1',
                value:'string1'
            },{
                label:'string2',
                value:'string2'
            },{
                label:'string3',
                value:'string3'
            },{
                label:'string4',
                value:'string4'
            }]
        },
        
        openEditPublicTableDialog(row){
            this.isEdit = true;
            this.dialogAddTableVisible = true;
            this.isPublicTable = true;
            this.tableType = 1;
            this.tableDataId = row.id;
            this.bindInputBlurEventHandler();
            this.bindSelectBlurHandler();
            this.clearDialogFormData();

            getTableFieldListDetail("one_holiday",1,this.pageUrl_,this.projectId,row?row.id:0).then((res)=>{
                console.log(res.data.data);
                this.dialogViewData = res.data.data;
                if(row){
                    this.publichead.publicTableDesc = row.publicTableDesc
                    this.publichead.remark = row.publicTableRemark
                    this.tableData = this.transformNumberToBoolean(this.dialogViewData.publicFields);
                    this.bindInputBlurEventHandler();
                    this.bindSelectBlurHandler();
                }
            })
        },
        transformNumberToBoolean(list){
            let list_ = [];
            list.forEach((e,i)=>{
                if(parseInt(e.dbIsKey)){
                    e.dbIsKey = true;
                }else{
                    e.dbIsKey = false;
                }
                if(parseInt(e.dbIsNull)){
                    e.dbIsNull = true;
                }else{
                    e.dbIsNull = false;
                }
                list_.push(e);
            });
            return list_;
        },
        openAddPublicTableDialog(){
            this.isEdit = false;
            this.dialogAddTableVisible = true;
            this.isPublicTable = true;
            this.tableType = 1;
            this.bindInputBlurEventHandler();
            this.bindSelectBlurHandler();
            this.clearDialogFormData();
            getTableFieldListDetail("one_holiday",1,this.pageUrl_,this.projectId).then((res)=>{
                console.log(res.data.data);
                this.dialogViewData = res.data.data;
            })
        },
        bindInputBlurEventHandler(){
            let self = this;
            setTimeout(()=>{
                let _el_ = document.querySelector('#tableEditBox');
                _el_.querySelectorAll('div.el-table__body-wrapper.is-scrolling-none > table input.el-input__inner')
                .forEach((e,i)=>{
                    e.addEventListener('blur',(e)=>{
                        console.log(e);
                        console.log(e.target);
                        //初始化样式
                            // self.submitBtnDisabled = false;
                        e.target.style.border = '';
                        if(!e.target.value){
                            e.target.style.border = '1px solid red';
                            console.log('empty value');
                            // self.submitBtnDisabled = true;
                            
                            self.isInputEmptyCounts++;
                        }
                    });
                });
            },0);
        },
        clearDialogFormData(){
            setTimeout(()=>{
                // let _el_ = document.querySelector('#tableEditBox');
                // _el_.querySelectorAll('div.el-table__body-wrapper.is-scrolling-none > table input.el-input__inner').value = '';
                this.tableData = [{
                                        dbFieldName: 'id',
                                        dbFieldDesc: '主键',
                                        queryDictField: '',
                                        queryDictText: '',
                                        queryDefVal: '',
                                        queryDictTable: '',
                                        queryConfigFlag: '0',
                                        mainTable: '',
                                        mainField: '',
                                        fieldHref: '',
                                        dictField: '',
                                        dictText: '',
                                        fieldMustInput: '0',
                                        dictTable: '',
                                        fieldLength: '120',
                                        fieldDefaultValue: '',
                                        fieldExtendJson: '',
                                        converter: '',
                                        isShowForm: '0',
                                        isShowList: '0',
                                        sortFlag: '0',
                                        isReadOnly: '1',
                                        fieldShowType: 'text',
                                        isQuery: '0',
                                        queryMode: 'single',
                                        dbLength: '64',
                                        dbPointLength: '0',
                                        dbDefaultValue: '',
                                        orderNum: '1',
                                        dbType: '3',
                                        dbIsKey: true,
                                        dbIsNull: false,
                                        order_num: '0'
                                    },{
                                        dbFieldName: 'main_id',
                                        dbFieldDesc: '主表id',
                                        queryDictField: '',
                                        queryDictText: '',
                                        queryDefVal: '',
                                        queryDictTable: '',
                                        queryConfigFlag: '0',
                                        mainTable: '',
                                        mainField: '',
                                        fieldHref: '',
                                        dictField: '',
                                        dictText: '',
                                        fieldMustInput: '0',
                                        dictTable: '',
                                        fieldLength: '120',
                                        fieldDefaultValue: '',
                                        fieldExtendJson: '',
                                        converter: '',
                                        isShowForm: '0',
                                        isShowList: '0',
                                        sortFlag: '0',
                                        isReadOnly: '1',
                                        fieldShowType: 'text',
                                        isQuery: '0',
                                        queryMode: 'single',
                                        dbLength: '64',
                                        dbPointLength: '0',
                                        dbDefaultValue: '',
                                        orderNum: 1,
                                        dbType: '3',
                                        dbIsKey: false,
                                        dbIsNull: false,
                                        order_num: '0'
                                    }];
                                    
          this.publichead={
                pageUrl: '',
                tableName: "",
                publicTableDesc: "",
                remark: ""
            };
          this.head={
                pageUrl: '',
                tableName: "",
                extendTableDesc: "",
                remark: ""
            };

            });
        },
        bindSelectBlurHandler(){
            setTimeout(()=>{
                let _el_ = document.querySelector('#tableEditBox');
                _el_.querySelectorAll('input[name="dbType"]').forEach((e,i)=>{
                    e.addEventListener('focus',(event)=>{
                        setTimeout(()=>{
                            let el_ = _el_.querySelectorAll('input[name="dbPointLength"]')[i]
                            el_.disabled = true;
                            el_.parentNode.className = 'el-input is-disabled'
                            if(event.target.value==="BigDecimal"){
                                console.log(el_.disabled);
                                el_.disabled = false;
                                el_.parentNode.className = 'el-input'
                            }else{
                                el_.value = 0;
                            }
                        })
                    });
                })
            });
        },
        openEditExtendTableDialog(row){
            this.isEdit = true;
            this.tableDataId = row.id;
            this.initExtendTableDetail(row);
        },
        initExtendTableDetail(row){
            this.dialogAddTableVisible = true;
            this.isPublicTable = false;
            
            this.tableType = 2;
            this.bindInputBlurEventHandler();
            this.bindSelectBlurHandler();
            this.clearDialogFormData();
            getTableFieldListDetail("one_holiday",2,this.pageUrl_,this.projectId,row?row.id:'').then((res)=>{
                console.log(res.data.data);
                this.dialogViewData = res.data.data;
                if(row){
                    // this.dialogViewData.extendTableRemark = row.extendTableRemark;
                    // this.dialogViewData.extendTableDesc = row.extendTableDesc;
                    this.head.extendTableDesc = row.extendTableDesc;
                    this.head.remark = row.extendTableRemark;
                    this.tableData = this.transformNumberToBoolean(this.dialogViewData.extendFields);
                    this.bindInputBlurEventHandler();
                    this.bindSelectBlurHandler();
                }
            })
        },
        openAddExtendTableDialog(){
            this.isEdit = false;
            this.initExtendTableDetail();
        },

deleteExtendTableHandler(id){

    this.$confirm("确定删除该数据表?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    }).then(() => {
        removeExtendTable(id).then((res)=>{
            console.log(res);
            if(res.data.code == 200){
                this.tableExtendLoading = true;
                getExtensionTableList(this.pageUrl_,this.pageExtendOption.currentPage,this.pageExtendOption.pageSize,this.projectId).then(({ data })=>{
                    console.log("扩展表列表===>",data.data.records);
                    this.dataListExtension = data.data.records;
                    this.pageExtendOption = {
                        total:data.data.total,
                        pageSize:data.data.size,
                        currentPage:data.data.current
                    }
                    this.tableExtendLoading = false;
                });
            }
        })
    });


},
deletePublicTableHandler(id){
    
    this.$confirm("确定删除该数据表?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    }).then(() => {
    removePublicTable(id).then((res)=>{
        console.log(res);
        if(res.data.code == 200){

            this.tablePublicLoading = true;
                        getPublicTableList(this.pageUrl_,this.pagePublicOption.currentPage,this.pagePublicOption.pageSize).then(({ data })=>{
                            console.log("共享表列表===>",data.data.records);
                            this.pagePublicOption = {
                                total:data.data.total,
                                pageSize:data.data.size,
                                currentPage:data.data.current
                            }
                            this.dataListPublic = data.data.records;
                            console.log(this.pagePublicOption);
                            this.tablePublicLoading = false;
                        });
        }
    })
    
    });
}


    }
  }
</script>

<style>

</style>
